import React, { forwardRef } from 'react';

import { isInteger } from 'lodash-es';

import NotificationsIcon from '@mui/icons-material/Notifications';
import { ListItemButton, ListItemIcon, Stack, Typography } from '@mui/material';

import {
  navItemActiveStyling,
  navItemHoverStyling,
  navItemTransition,
} from '@/components/shared/PrimaryNavDrawer/utils';
import { notificationCircleStyling } from '@/pages/NotificationSettings/utils';

type PrimaryNavNotificationProps = {
  isCurrentPage: boolean;
  isDrawerOpen: boolean;
  isItemBadgeVisible?: boolean;
  onItemClick?: (anchorEl: HTMLDivElement) => void;
  Counter?: React.ReactNode;
  'data-cy'?: string;
  unreadCount?: number;
};

const PrimaryNavNotification = forwardRef<
  HTMLDivElement,
  PrimaryNavNotificationProps
>((props, ref) => {
  const {
    isCurrentPage,
    isDrawerOpen,
    isItemBadgeVisible,
    onItemClick,
    Counter,
    'data-cy': dataCy,
    unreadCount,
  } = props;
  const notificationId = Counter ? 'notification-feed' : undefined;
  const shouldAnimate =
    !!isItemBadgeVisible && !isDrawerOpen && isInteger(unreadCount);

  return (
    <>
      <ListItemButton
        ref={ref}
        aria-describedby={notificationId}
        sx={{
          px: 1.5,
          py: 0.75,
          '&:hover': navItemHoverStyling,
          ...(isCurrentPage && navItemActiveStyling),
        }}
        onClick={(e) => onItemClick?.(e.currentTarget)}
        data-cy={dataCy}
      >
        <ListItemIcon
          sx={{
            minWidth: 40,
            position: 'relative',
          }}
        >
          <NotificationsIcon sx={{ color: 'neutral00' }} />
          <Stack
            data-cy="notification-badge"
            sx={{
              alignItems: 'center',
              justifyContent: 'center',

              ...notificationCircleStyling({
                isCurrentPage,
                isVisible: !!isItemBadgeVisible && !isDrawerOpen,
              }),

              ...(shouldAnimate && { width: 15, height: 15 }),
              fontSize: '0.6rem',
            }}
          >
            {unreadCount}
          </Stack>
        </ListItemIcon>

        <Typography component="span" sx={navItemTransition(isDrawerOpen)}>
          Notifications
        </Typography>

        {Counter}
      </ListItemButton>
    </>
  );
});

export default PrimaryNavNotification;
